export const ERROR_TEXTS_BY_BASE_LOCALE = {
    de: {
        buttonResetLabel: 'Schließen',
        headline: 'Pardon',
        text1: 'Leider ist gerade etwas schiefgelaufen.',
        text2: 'Wir sind über den Fehler informiert und werden uns schnellstmöglich darum kümmern. Wir bitten für diese Unannehmlichkeiten um Entschuldigung.'
    },
    en: {
        buttonResetLabel: 'Close',
        headline: 'Pardon',
        text1: 'Unfortunately, something has just gone wrong.',
        text2: 'We are aware of the error and will take care of it as soon as possible. We apologize for this inconvenience.'
    }
};


export const FALLBACK_BASE_LOCALE = 'en';
